module.exports = __webpack_public_path__ + "img/foto_marburg.a1a9decc.png";